import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
// Fonturile vin din site, nu de la Google (15 septembrie 2026): aceleasi fisiere si aceleasi
// grosimi ca inainte, prin pachetele Fontsource, ca adresa IP a vizitatorului sa nu mai ajunga
// la Google la fiecare deschidere. Inainte erau cerute cu @import din App.css.
import '@fontsource/dm-sans/300.css';
import '@fontsource/dm-sans/400.css';
import '@fontsource/dm-sans/500.css';
import '@fontsource/dm-sans/600.css';
import '@fontsource/dm-serif-display/400.css';
import './index.css';
import App from './App';
import Privacy from './Privacy';
import Terms from './Terms';
import Cookies from './Cookies';
import FacebookCallback from './FacebookCallback';
import TikTokCallback from './TikTokCallback';
import LinkedInCallback from './LinkedInCallback';
import ThreadsCallback from './ThreadsCallback';
import XCallback from './XCallback';
import NotFound from './NotFound';
import Settings from './Settings';
import PermitePriza from './PermitePriza';
import AprobareClient from './AprobareClient';
import FooterLegalMobil from './FooterLegalMobil';
import CookieBanner from './CookieBanner';

// Serverul de autentificare lipeste calea ecranului de permisiune de adresa site-ului, care se
// termina in bara: omul poate ajunge la `//oauth/consent`. Ruterul n-ar recunoaste-o.
if (window.location.pathname.startsWith('//')) {
  window.history.replaceState(window.history.state, '', window.location.pathname.replace(/^\/+/, '/') + window.location.search + window.location.hash);
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/cookies" element={<Cookies />} />
        <Route path="/auth/facebook/callback" element={<FacebookCallback />} />
        <Route path="/auth/tiktok/callback" element={<TikTokCallback />} />
        <Route path="/auth/linkedin/callback" element={<LinkedInCallback />} />
        <Route path="/auth/threads/callback" element={<ThreadsCallback />} />
        <Route path="/auth/x/callback" element={<XCallback />} />
        <Route path="/setari" element={<Settings />} />
        <Route path="/oauth/consent" element={<PermitePriza />} />
        {/* Pagina clientului din linkul de aprobare, fara cont (APROBARE_CLIENT_PLAN.md). */}
        <Route path="/aprobare/:cod" element={<AprobareClient />} />
        <Route path="/" element={<App />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <FooterLegalMobil />
      {/* Notificarea despre stocare, pe toate paginile si pentru toate rolurile. */}
      <CookieBanner />
    </BrowserRouter>
  </React.StrictMode>
);